import { ComponentPropsWithRef } from "react";

import styles from "./RadioButton.module.css";

export function RadioButton({ children, ...rest }: ComponentPropsWithRef<"input">) {
  return (
    <div className={styles.radioWrapper}>
      <label className={styles.radioLabel}>
        {children}
        <div className={styles.radioContainer}>
          <input type="radio" className={styles.radio} {...rest} />
        </div>
      </label>
    </div>
  );
}
